import React, { useState } from "react";
import get from "lodash/get";
import useUrl from "../../../hook/useUrl";
import { Link } from "@quintype/components";
import CardImage from "../../atoms/card-image";
import TimeStamp from "../../atoms/time-stamp";
import AuthorSlug from "../../atoms/author-name";
import { object, string, bool } from "prop-types";
import useStorage from "../../../hook/useStorage";
import { isFreeLimit } from "../../utils/isFreeLimit";
import LightBoxImage from "../../molecules/lightBox-image";
import SocialShareBottom from "../../story-templates/social-share";
import "./story-header-live-blog.m.css";
import aspectRatio from "../../utils/aspectRatio";

const StoryHeader = ({ story, isHeroImage = true }) => {
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = (isPopupOpen) => {
    setShowPopup(isPopupOpen);
  }
  const imgS3keys = story["hero-image-s3-key"];
  const ingressi = get(story, ["metadata", "ingressi"], []);
  const paikkakunta = get(story, ["metadata", "paikkakunta"], []);
  const isClosed = get(story, ["metadata", "is-closed"], []);
  const liveIndicator = get(story, ["metadata","story-attributes","paivittyvajuttu", 0]);
  const publishTime = story["published-at"];
  const updateTime = story["updated-at"];
  var storyUpdated = false;
  if (updateTime > publishTime) {
    storyUpdated = true;
  }

  const accessType = story.access;
  const [checkUser, activeProducts, whiteListed, allTagIds, visitCounts, articlesLimit, isVisitedSlug] = useStorage();
  const conditionalComponents = isFreeLimit(checkUser, activeProducts, visitCounts, articlesLimit, isVisitedSlug);
  const [_,currentUrlSlug]=useUrl();
  let domainSlug=""
  let sectionSlug=""
  /** switch cases */
  switch (currentUrlSlug) {
    case "vaasalehti":
      domainSlug="vaasa"
      sectionSlug = "vaasalehti";
      break;
    case "epari":
      domainSlug="epari"
      sectionSlug = "epari";
      break;
    case "":
      domainSlug="ilkka-pohjalainen"
      sectionSlug = "";
      break;
    default:
      domainSlug="ilkka-pohjalainen"
      sectionSlug = "";
  }
  /* getting url right regarding different papers*/
  function findByKey(key, value) {
    return (item, i) => item[key] === value
  }

  let findParams = findByKey("domain-slug", domainSlug) //change here
  let positionOfPaper = story.sections.findIndex(findParams)

  // Check if there is section for that paper (needed mainly for localhost)
  var sectionUrl = story.sections[positionOfPaper] ? (story.sections[positionOfPaper].slug) : (story.sections[0].slug)
  var sectionTag = story.sections[positionOfPaper] ? (((story.sections[positionOfPaper]["display-name"] !== "Epari") && (story.sections[positionOfPaper]["display-name"] !== "Vaasa-lehti")) ? story.sections[positionOfPaper]["display-name"] : "") : (story.sections[0]["display-name"]);
  const aspRto= aspectRatio(story);
  return (
    <div styleName="wrapper">
      {/* voice intuitive button to show only when the story component is showing instead of paywall */}
      <div className={`${((accessType === "login" || accessType === "subscription" || accessType === null) && (!checkUser || !conditionalComponents)) ?
        !whiteListed ? "" : "" : "voice-intuitive"}`} styleName="voice-intuitive-btn"></div>
      <div styleName="section-time" className="voice-no-read">
        {(sectionTag === "Yleisöltä" || sectionTag === "Pääkirjoitus" || sectionTag === "Kolumnit" || sectionTag === "Kentän laidalta" || sectionTag === "Menot ja mietteet") && <Link href={sectionSlug?`/${sectionSlug}/${sectionUrl}`:`/${sectionUrl}`}>
          <div styleName="section-tag">{sectionTag}</div>
        </Link>}
        <div styleName="time-wrapper"><TimeStamp timeStamp={story["published-at"]} />
          {(storyUpdated === true) ? (
            <div styleName="story-updated"><TimeStamp timeStamp={story["updated-at"]} /></div>
          ) : (
            null
          )}
        </div>
      </div>
      <div styleName="headline-wrapper">
          {(liveIndicator) ? (
            <div styleName="liveblog"><span styleName="blink"></span>{liveIndicator}</div>
          ) : (
            null
          )}
        <h1 styleName="story-headline">{story.headline}</h1>
      </div>
      {isHeroImage && (
        <React.Fragment>
          {imgS3keys && <div styleName="card-img" onClick={() => { togglePopup(true) }}>
            <CardImage aspectRatio={[aspRto[1],aspRto[0]]} story={story} defaultWidth={500} imageType="imageOriginalShape" />
          </div>}
          {(story["hero-image-caption"] || story["hero-image-attribution"]) && (
            <div styleName="hero-image-wrapper" className="voice-no-read">
              {story["hero-image-caption"] && (
                <figcaption styleName="image-caption" className="story-element-image-title">
                  {story["hero-image-caption"]}
                </figcaption>
              )}
              {story["hero-image-attribution"] && (
                <figcaption className="story-element-image-title">Kuva: {story["hero-image-attribution"]}</figcaption>
              )}
            </div>
          )}
          {showPopup && (
            <LightBoxImage
              story={story}
              closePopup={() => togglePopup()}
              isHeroImage={true}
            />
          )}
          <AuthorSlug authors={story.authors} />

          {paikkakunta.length > 0 && (<div styleName="section-place">

            <Link styleName="place">{paikkakunta} </Link>
          </div>)}
          <div styleName="social-share-top">
            <SocialShareBottom story={story} />
          </div>
        </React.Fragment>
      )}
      <div styleName="story-lead">{ingressi}</div>
    </div>
  );
};

StoryHeader.propTypes = {
  story: object,
  sectionName: string,
  isHeroImage: bool
};

export default StoryHeader;
